import { Link } from "react-router";
import { Button, Modal } from "semantic-ui-react";
import { useDisclosure } from "@iscr/xAppLib/Hooks/useDisclosure";

export function NoMedicareCardModal({children = `I don't have a Medicare card.`}) {
	const modal = useDisclosure();
	const trigger = <Link to="#" className="text-site-brand" onClick={modal.onOpen}>{children}</Link>;

	return (
		<Modal trigger={trigger} open={modal.isOpen} onClose={modal.onClose} onOpen={modal.onOpen} size="mini">
			<Modal.Header>
				<span className="text-muted-foreground">What if I do not have a Medicare card?</span>
			</Modal.Header>
			<Modal.Content className="text-tertiary">
				<p>
					If you do not have a valid Medicare card, you may obtain an Individual Health Identifier (IHI)
					via <a className="text-site-brand"
						   href="https://www.servicesaustralia.gov.au/individual-healthcare-identifiers"
						   target="_blank">Individual Healthcare Identifiers – Services Australia.</a>
				</p>
				<p>
					If you do have a valid IHI, please share those details with Support team, 
					via <a className="text-site-brand"
					   href="mailto:support@instantscripts.com.au">support@instantscripts.com.au</a>, so we can help
					further.
				</p>
			</Modal.Content>
			<Modal.Actions>
				<Button basic
						type="button"
						fluid
						onClick={modal.onClose}
						className="!w-full"
				>
					Close
				</Button>
			</Modal.Actions>
		</Modal>
	);
}
